import { api } from '../lib/api'

export type BillingSummary = {
  plan: {
    name: string
    status: string
    current_period_end: string | null
    price_usd: number
    stripe_subscription_id?: string
  }
  auto_refill: {
    enabled: boolean
    threshold_pixe: number
    amount_pixe: number
    max_usd_per_month: number | null
  }
  payment_method: {
    brand: string
    last4: string
    exp_month: number
    exp_year: number
  } | null
  portal: {
    enabled: boolean
  }
  capabilities?: {
    stripe_configured?: boolean
    wallet_ready?: boolean
  }
}

export type AutoRefillSettings = {
  enabled: boolean
  threshold_pixe: number
  amount_pixe: number
  max_usd_per_month?: number | null
}

export async function getBillingSummary() {
  const { data } = await api.get<BillingSummary>('/api/billing/summary/')
  return data
}

export async function updateAutoRefill(settings: AutoRefillSettings) {
  const { data } = await api.put('/api/billing/auto-refill/', settings)
  return data
}

export async function createSetupIntent() {
  const { data } = await api.post<{ client_secret: string }>('/api/billing/setup-intent/', {})
  return data
}

export async function createPortalSession(returnUrl?: string) {
  const { data } = await api.post<{ url: string }>('/api/billing/portal/', { return_url: returnUrl })
  return data
}

export async function createEmbeddedSubscriptionSession(priceId: string, returnUrl?: string) {
  const { data } = await api.post<{ client_secret: string }>('/api/billing/embedded-checkout/subscription/', {
    price_id: priceId,
    return_url: returnUrl,
  })
  return data
}

export type CreateSubscriptionRequest = {
  tier: 'creator' | 'creator_pro'
  interval: 'month'
}

export type CreateSubscriptionResponse = {
  client_secret?: string
  subscription_id: string
  customer_id?: string
  amount_cents?: number
  currency?: string
  requires_confirmation?: boolean
  upgraded?: boolean
}

export async function createSubscriptionIntent(payload: CreateSubscriptionRequest) {
  const { data } = await api.post<CreateSubscriptionResponse>('/api/billing/subscriptions/create/', payload)
  return data
}

export async function upgradeSubscriptionIntent(payload: CreateSubscriptionRequest) {
  const { data } = await api.post<CreateSubscriptionResponse>('/api/billing/subscriptions/upgrade/', payload)
  return data
}

export async function cancelSubscription() {
  const { data } = await api.post<{ canceled: boolean; already_canceled?: boolean; summary: BillingSummary }>(
    '/api/billing/subscriptions/cancel/',
    {}
  )
  return data
}
